import { userUtils } from '@/utils/auth'
import axios from 'axios'
import { Notify } from 'vant'
import router from '../router'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_SPI_SERVER, // api 的 base_url
  timeout: 1000 * 60 * 5, // request timeout
  withCredentials: true
})

// request interceptor
service.interceptors.request.use(
  config => {
    console.log(config)
    // const whiteList = ['/auth/token/refresh', '/auth/login']
    // let needRefresh = true
    // for (let i = 0; i < whiteList.length; i++) {
    //   if (config.url.indexOf(whiteList[i]) >= 0) {
    //     needRefresh = false
    //     break
    //   }
    // }
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (!response.config.disableError && response.data.resultCode && response.data.resultCode !== '0' && response.data.resultMsg) {
      Notify({
        message: response.data.resultMsg,
        background: 'rgba(255, 68, 68, 0.9)',
        className: 'notify-error-msg'
      })
    }
    return response
  },
  error => {
    console.log(error)
    if (error.response) {
      if (error.response.status === 500) {
        Notify('接口请求异常')
      } else if (error.response.status === 401) {
        // Notify('登录过期')
        userUtils.removeUserLocal()
        setTimeout(() => {
          router.push({
            name: 'login2',
            params: {
              redirectUrl: 'home-main'
            }
          })
        }, 1000)
      } else {
        Notify('服务器异常')
      }
    } else {
      Notify('网络异常')
    }
    return Promise.reject(error)
  }
)

export default service
